<template>
  <div
    class="gallery-card"
    :class="{
      loading: item.loading,
      result: !!item.resultUrl && !item.loading,
      'is-empty': !item.resultUrl && !item.loading,
    }"
    :style="cardStyle"
  >
    <template v-if="item.loading">
      <div class="pulse-bg"></div>
      <div class="card-center">
        <div class="ring">
          <svg class="ring-svg" viewBox="0 0 100 100">
            <circle class="ring-track" cx="50" cy="50" r="40"></circle>
            <circle
              class="ring-stroke"
              cx="50"
              cy="50"
              r="40"
              :style="{
                strokeDashoffset: 251.2 * (1 - (item.progress ?? 0) / 100),
              }"
            ></circle>
          </svg>
          <div class="ring-text">{{ Math.round(item.progress ?? 0) }}%</div>
        </div>
        <p class="load-text">裂变融合中...</p>
      </div>
    </template>

    <template v-else-if="item.resultUrl">
      <img :src="item.resultUrl" class="card-img" alt="fission result" />
      <div class="overlay"></div>
      <div class="card-actions">
        <button
          class="action-btn glass"
          title="重新生成该图"
          @click.stop="workbench.generateOneFission(index)"
        >
          <svg
            class="icon-sm"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </button>

        <button
          class="action-btn glass"
          title="预览"
          @click.stop="workbench.openLightbox(item.resultUrl)"
        >
          <svg
            class="icon-sm"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
        </button>

        <button
          class="action-btn blue"
          title="下载"
          @click.stop="workbench.downloadImage(item.resultUrl)"
        >
          <svg
            class="icon-sm"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
        </button>
      </div>
    </template>

    <template v-else>
      <div class="empty-card" style="color: #94a3b8; font-size: 13px">
        等待生成
      </div>
    </template>

    <div class="fission-source-thumb" title="参考底图">
      <img :src="item.sourceUrl" alt="source" />
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { computed } from "vue"; // 必须引入 computed
import { useWorkbenchStore } from "@/stores/useWorkbenchStore";

defineProps({
  index: {
    type: Number,
    required: true,
  },
  item: {
    type: Object,
    required: true,
  },
});

const workbench = useWorkbenchStore();

// === 新增：动态计算裂变图卡片的比例 ===
const cardStyle = computed(() => {
  // 裂变使用的是生成宣传图时设置的比例
  const currentRatio = workbench.promo.ratio || "1:1";
  return {
    aspectRatio: currentRatio.replace(":", " / "),
  };
});
</script>
